import { VisibilityOff, Visibility } from "@mui/icons-material";
import {
  Alert,
  Button,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  OutlinedInput,
  Typography,
  Box,
} from "@mui/material";
import React, { useState, FormEvent, KeyboardEvent } from "react";
import LoginIcon from "@mui/icons-material/Login";
import { useAuth } from "../hooks/useAuth";
import { env } from "../config/env";

interface LoginFormState {
  password: string;
  showPassword: boolean;
  isIncorrectPassword: boolean;
}

export const Login = () => {
  const [formState, setFormState] = useState<LoginFormState>({
    password: "",
    showPassword: false,
    isIncorrectPassword: false,
  });
  
  const { login } = useAuth();

  const handleClickShowPassword = () => {
    setFormState(prev => ({ ...prev, showPassword: !prev.showPassword }));
  };

  const handlePasswordChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setFormState(prev => ({
      ...prev,
      password: event.target.value,
      isIncorrectPassword: false,
    }));
  };

  const handleLoginSuccess = () => {
    login();
    window.location.reload();
  };

  const handleLoginAttempt = (event: FormEvent<HTMLFormElement>): void => {
    event.preventDefault();
    
    if (formState.password === env.password) {
      handleLoginSuccess();
    } else {
      setFormState(prev => ({
        ...prev,
        password: "",
        isIncorrectPassword: true,
      }));
    }
  };

  const handleKeyDown = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault();
      if (formState.password === env.password) {
        handleLoginSuccess();
      } else {
        setFormState(prev => ({
          ...prev,
          password: "",
          isIncorrectPassword: true,
        }));
      }
    }
  };

  return (
    <Box sx={{ width: "80%", margin: "auto", marginTop: "20vh" }}>
      <Typography variant="h3" gutterBottom>
        Canada Elite Circle Login
      </Typography>
      <form onSubmit={handleLoginAttempt}>
        <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
          <InputLabel htmlFor="password" error={formState.isIncorrectPassword}>
            Password
          </InputLabel>
          <OutlinedInput
            error={formState.isIncorrectPassword}
            required
            id="password"
            type={formState.showPassword ? "text" : "password"}
            value={formState.password}
            onChange={handlePasswordChange}
            onKeyDown={handleKeyDown}
            endAdornment={
              <InputAdornment position="end">
                <IconButton
                  aria-label="toggle password visibility"
                  onClick={handleClickShowPassword}
                  onMouseDown={(e) => e.preventDefault()}
                  edge="end"
                >
                  {formState.showPassword ? <VisibilityOff /> : <Visibility />}
                </IconButton>
              </InputAdornment>
            }
            label="Password"
          />
        </FormControl>
        {formState.isIncorrectPassword && (
          <Alert variant="outlined" severity="error" sx={{ width: "25ch", margin: "auto" }}>
            Incorrect Password
          </Alert>
        )}
        <Box sx={{ mt: 2 }}>
          <Button type="submit" variant="contained" size="large" endIcon={<LoginIcon />}>
            Login
          </Button>
        </Box>
      </form>
    </Box>
  );
};
